import { render, staticRenderFns } from "./StaffPlanEdit.vue?vue&type=template&id=736769bd"
import script from "./StaffPlanEdit.vue?vue&type=script&lang=js"
export * from "./StaffPlanEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports